import { useEffect } from "react";

import XClose from "@uui/XClose";

import useLocalStorage from "@app/common/hooks/useLocalStorage";

import Alert from "@rui/Alert";
import IconButton from "@rui/IconButton";
import { Bold } from "@rui/styles";

const RecommendationsSampleDataBanner = ({
  autoDismiss,
  onDisableSampleData,
}: {
  autoDismiss: boolean;
  onDisableSampleData: () => void;
}) => {
  const [bannerDismissed, setBannerDismissed] = useLocalStorage<boolean | null>(
    "sampleRecommendationsDismissed",
    null
  );

  const handleDismiss = () => {
    if (autoDismiss) onDisableSampleData();
    setBannerDismissed(true);
  };

  useEffect(() => {
    if (autoDismiss) {
      if (!bannerDismissed) handleDismiss();
      return;
    }

    if (bannerDismissed == null) {
      // the banner will be auto-dismissed if the user has real recommendations. if the user
      // doesn't have real recommendations, update from null to false so that the banner appears
      setBannerDismissed(false);
    }
  }, [autoDismiss, bannerDismissed]);

  if (bannerDismissed || bannerDismissed == null) return null;

  return (
    <Alert
      severity="info"
      dismissible
      onDismiss={handleDismiss}
      renderDismissButton={({ onClick }) => (
        <IconButton onClick={onClick} size="small">
          <XClose sx={{ fontSize: "18px" }} />
        </IconButton>
      )}
    >
      <Bold>Sample Recommendations:</Bold> You don't have any recommendations
      yet, so Read populated these sample recommendations to show you what to
      expect. Interacting with these will not affect any calendar events.
    </Alert>
  );
};

export default RecommendationsSampleDataBanner;
